import React from 'react'
import {Progress} from 'reactstrap'

const progress=(props)=>(<Progress {...props} />)

export default progress
